import ErrorTable from "../componens/errorTable";
export default function ErrorLog({ canDelete = false }) {
  return <ErrorTable canDelete={canDelete} />;
}
